module.exports = __webpack_public_path__ + "63345fa7c022876582818d56dd4d3718.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-6.jpg
// module id = 86
// module chunks = 0